export default {
  buttons: {
    skip: 'Überspringen',
    back: 'Zurück',
  },
  toasts: {
    failed_to_load_data: 'Daten konnten nicht geladen werden',
    payment: {
      pending: 'Ihre Zahlung wird gerade bearbeitet...',
      success: '👍 Ihre Zahlung wurde erfolgreich bearbeitet. Wir danken Ihnen!',
      error:
        '⁉️Es gab ein Problem mit Ihrer Zahlung oder die Bearbeitung dauert länger als erwartet. Bitte versuchen Sie, die Seite für 1 Minute zu aktualisieren, andernfalls kontaktieren Sie den technischen Support.',
    },
  },
};
